export default async function hasAccess({
  next,
  store,
  to,
  nextMiddleware
}) {
  const getters = store.getters
  const dispatch = store.dispatch

  const { projectId } = to.params || {}

  await dispatch('account/fetchAccess', { type: 'system', withPermissionsSlugIndex: true, withPermissionsSlugNewIndex: true }, { root: true })
  projectId && await dispatch('account/fetchAccess', { type: 'project', projectId, withRolesDescription: true, withPermissionsSlugIndex: true, withPermissionsSlugNewIndex: true }, { root: true })

  const { access } = to.meta || {}

  const { permission: permissions = [], licenceAbility: licenses = [], settings = [] } = access || {}

  const { value } = getters['account/getAccessWithMessage']({
    permissions: array(permissions), 
    licenses: array(licenses),
    settings: array(settings)
  })

  return value || !access ? nextMiddleware() : next({ name: 'error' })
}
